/* eslint-disable no-nested-ternary */
import { classnames } from '@aibees/shared/utils';
import { Button, Divider, Stack } from '@mui/material';
import { memo, useCallback } from 'react';
import { COMPARE_PLANS_SCROLL_ID } from '@aibees/shared/features/price-and-plan/components/collapsed-table/config';
import { usePlanCardContext } from '../../context';
import * as SX from './sx';
import type { PlanComparePlansProps as Props } from './types';

export const PlanComparePlans = memo(({ className }: Props) => {
  const { isMostPopular } = usePlanCardContext();

  const handleScroll = useCallback(() => {
    document
      .getElementById(COMPARE_PLANS_SCROLL_ID)
      ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, []);

  return (
    <Stack className={classnames('PlanComparePlans', className)} sx={SX.root}>
      <Divider flexItem />
      <Button
        size="small"
        variant={isMostPopular ? 'contained' : 'text'}
        color={isMostPopular ? 'primary' : 'default'}
        onClick={handleScroll}
      >
        Compare Plans
      </Button>
    </Stack>
  );
});

PlanComparePlans.displayName = 'PlanComparePlans';
